// import { canUseDOM } from 'exenv';

export function htmlSitemapIndexLoading(resp = {}, store = {}) {
  return {
    type: 'HTML_SITEMAP_INDEX_LOADING',
    htmlSitemapIndex: resp,
    store
  };
}

export function htmlSitemapIndexLoaded(resp = {}, store = {}) {
  return {
    type: 'HTML_SITEMAP_INDEX_LOADED',
    htmlSitemapIndex: resp,
    store
  };
}

export function htmlSitemapIndexError(error, store = {}) {
  return {
    type: 'HTML_SITEMAP_INDEX_ERROR',
    htmlSitemapIndex: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store
  };
}
